var map = {
	"./flash1.jpeg": 7187,
	"./flash2.jpeg": 2814,
	"./flash3.jpeg": 8078,
	"./flash4.jpeg": 1809,
	"./flash5.jpeg": 5056,
	"./flash6.jpeg": 7121,
	"./flash7.jpeg": 3459,
	"./flash8.jpeg": 6603
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1386;